import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState('vacancies', [
      'staticRouteFilters',
      'staticFiltersKeys',
      'otherKeys',
    ]),
    staticFiltersKeysSlugs() {
      return Object.values(this.staticFiltersKeys)
    }
  },
  methods: {
    getRouteWithNewDynamicFilterMixin(newFilterKey, newFilterValue) {
      const dynamicFilters = this.dynamicFilters
      const dynamicRouteFilters = this.dynamicRouteFilters

      const dynamicRouteFiltersKeys = Object.keys(dynamicRouteFilters)
      dynamicRouteFiltersKeys.push(newFilterKey)

      return dynamicFilters.reduce((result, filter) => {
        if (dynamicRouteFiltersKeys.includes(filter.slug)) {
          let value = filter.slug === newFilterKey ? newFilterValue : dynamicRouteFilters[filter.slug]
          if (!value.length) return result

          value = filter.data.reduce((valueResult, item) => {
            if (value.includes(item.slug)) {
              valueResult.push(item.slug)
            }
            return valueResult
          }, [])

          value = value.join('|')

          result.push(`${filter.slug}-${value}`)
        }

        return result
      }, [])
    },
    pushToRouterNewDynamicFilterMixin(newFilterKey, newFilterValue) {
      const newDynamicRouteFilters = this.getRouteWithNewDynamicFilterMixin(newFilterKey, newFilterValue)

      this.pushToRouterMixin({
        params: {
          dynamicFilters: newDynamicRouteFilters
        }
      })

      if (newDynamicRouteFilters.length) {
        this.$store.dispatch('sendAlert', {
          type: 'filter',
          title: 'Dynamic filter',
          params: `${newDynamicRouteFilters}`
        })
      }
    },
    getRouteMixin({params, query}) {
      const $route = this.$route

      const newRoute = {
        params: {
          ...$route.params,
          ...params
        },
        query: {
          categories: $route.query.categories || null,
          [this.otherKeys.SORT]: $route.query[this.otherKeys.SORT],
          ...query
        }
      }

      //console.log('newRoute', newRoute)

      const staticFilters = newRoute.params.staticFilters
      const dynamicFilters = newRoute.params.dynamicFilters

      if (!newRoute.query.categories) {
        delete newRoute.query.categories
      }

      if (isArrayEmpty(staticFilters) && isArrayEmpty(dynamicFilters)) {
        newRoute.name = 'vacancies'
      } else if (isArrayEmpty(staticFilters)) {
        newRoute.name = 'vacancies-with-dynamic'
      } else if (isArrayEmpty(dynamicFilters)) {
        newRoute.name = 'vacancies-with-static'
      } else {
        newRoute.name = 'vacancies-with-static&dynamic'
      }

      return newRoute
    },
    pushToRouterMixin({params, query}) {
      const newRoute = this.getRouteMixin({params, query})

      this.$router.push(newRoute)
    },
    setStaticFilter(slug, value) {
      let newFilters = JSON.parse(JSON.stringify(this.staticRouteFilters))
      newFilters[slug] = value

      newFilters = this.staticFiltersKeysSlugs.reduce((result, slug) => {
        if (newFilters[slug]) {
          result.push(`${slug}-${newFilters[slug]}`)
        }

        return result
      }, [])

      this.pushToRouterMixin({
        params: {
          staticFilters: newFilters
        }
      })
    },
    setStaticFilters(receivedFilters) {
      let newFilters = JSON.parse(JSON.stringify(this.staticRouteFilters))

      Object.assign(newFilters, receivedFilters)


      newFilters = this.staticFiltersKeysSlugs.reduce((result, slug) => {
        if (newFilters[slug]) {
          result.push(`${slug}-${newFilters[slug]}`)
        }

        return result
      }, [])

      this.pushToRouterMixin({
        params: {
          staticFilters: newFilters
        }
      })
    }
  }
}


function isArrayEmpty(arr) {
  return !arr || !arr.length
}
